import { render, staticRenderFns } from "./ProcesoCompraSinRecinto.vue?vue&type=template&id=08b3473e"
import script from "./ProcesoCompraSinRecinto.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraSinRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports